import {Alert} from 'react-bootstrap'

const EqxError = function (props: {error: string}) {
    return <Alert variant="danger">{props.error}</Alert>
}
export default EqxError
